package org.wordsapp.ui.component

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.rememberUpdatedState
import kotlinx.browser.window
import org.w3c.dom.events.Event
import org.w3c.dom.events.KeyboardEvent

@Composable
actual fun OnEnterKey(onPressed: () -> Unit) {
    val currentHandler by rememberUpdatedState(onPressed)
    DisposableEffect(Unit) {
        val listener: (Event) -> Unit = { event ->
            val ke = event as? KeyboardEvent
            if (ke != null && ke.key == "Enter" && !ke.defaultPrevented) {
                currentHandler()
            }
        }
        window.addEventListener("keydown", listener)
        onDispose { window.removeEventListener("keydown", listener) }
    }
}
